import "../extensions/object";
import "es6-promise/auto";
var AjaxGlobals = /** @class */ (function () {
    function AjaxGlobals() {
    }
    AjaxGlobals.GetInstance = function () {
        if (!AjaxGlobals.instance) {
            AjaxGlobals.instance = new AjaxGlobals();
        }
        return AjaxGlobals.instance;
    };
    AjaxGlobals.prototype.GetDefaultData = function () {
        return this.defaultData;
    };
    AjaxGlobals.prototype.SetDefaultData = function (data) {
        this.defaultData = Object.merge(this.defaultData, data);
    };
    return AjaxGlobals;
}());
var AjaxRequest = /** @class */ (function () {
    function AjaxRequest() {
    }
    AjaxRequest.prototype.Send = function (method, url, data, options) {
        return new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (this.readyState === 4) {
                    var response = new AjaxResponse();
                    response.xhr = request;
                    response.data = this.response;
                    response.status = this.status;
                    response.statusText = this.statusText;
                    if (this.status >= 200 && this.status <= 204) {
                        resolve(response);
                    }
                    if (this.status >= 400) {
                        reject(response);
                    }
                }
            };
            data = Object.merge(AjaxRequestGlobals.GetDefaultData(), data);
            var dataString = Object.param(data);
            dataString = dataString.replace(new RegExp("^[&]+|[&]+$", "igm"), "");
            if (method == AjaxMethod.GET) {
                url = url + "?" + dataString;
                dataString = "";
            }
            console.log(url);
            request.open(method, url, true);
            if (options) {
                if (options.ResponseType) {
                    request.responseType = options.ResponseType;
                }
                if (options.RequestType) {
                    request.setRequestHeader("Content-Type", options.RequestType);
                }
            }
            request.send(dataString);
        });
    };
    return AjaxRequest;
}());
export { AjaxRequest };
export var AjaxMethod;
(function (AjaxMethod) {
    AjaxMethod["POST"] = "POST";
    AjaxMethod["GET"] = "GET";
    AjaxMethod["PUT"] = "PUT";
    AjaxMethod["UPDATE"] = "UPDATE";
    AjaxMethod["DELETE"] = "DELETE";
})(AjaxMethod || (AjaxMethod = {}));
export var AjaxRequestType;
(function (AjaxRequestType) {
    AjaxRequestType["JSON"] = "application/json;charset=UTF-8";
    AjaxRequestType["FORM"] = "application/x-www-form-urlencoded";
    AjaxRequestType["MULTIPART"] = "multipart/form-data";
    AjaxRequestType["PLAIN"] = "text/plain";
})(AjaxRequestType || (AjaxRequestType = {}));
export var AjaxResponseType;
(function (AjaxResponseType) {
    AjaxResponseType["JSON"] = "json";
    AjaxResponseType["TEXT"] = "text";
    AjaxResponseType["HTML"] = "document";
    AjaxResponseType["XML"] = "document";
    AjaxResponseType["ARRAY_BUFFER"] = "arraybuffer";
    AjaxResponseType["BLOB"] = "blob";
})(AjaxResponseType || (AjaxResponseType = {}));
var AjaxResponse = /** @class */ (function () {
    function AjaxResponse() {
    }
    return AjaxResponse;
}());
export { AjaxResponse };
export var AjaxRequestGlobals = AjaxGlobals.GetInstance();
